"use client"

import { client } from "@/lib/client"
import { InstantSearch, TrendingItems } from "react-instantsearch"
import { useTranslate } from "@tolgee/react"

export const AlgoliaTrendingListings = () => {
  const {t} = useTranslate()
  return (
    <InstantSearch searchClient={client} indexName="products" routing>
      <section className="py-8 w-full">
        <h2 className="mb-6 heading-lg font-bold tracking-tight uppercase">
          {t("algolia_trending_listings.trending_listings")}
        </h2>

        <TrendingItems
          limit={4}
          emptyComponent={() => <div>{t("algolia_trending_listings.no_recommendation")}</div>}
        />
      </section>
    </InstantSearch>
  )
}
